import axios from 'axios';

export const getLastBlock = async () => {
    try {
      const baseUrl = 'https://blockchain.info'
      const res = await axios.get(`${baseUrl}/q/getblockcount`)
      return res?.data
    } catch (err) {
      console.error('Failed to get network difficulty:', err)
      return 0;
    }
  }

export const getPayments = async (email) => {
    try {
        const resp = await axios.get(`https://pplp.titan.io/payments/${email}`)
        if(resp.status === 204) {
            return [];
        }
        return resp.data || [];
    }
    catch(e) {
        console.error(e.message);
        return [];
    }
}

export const getLastShareInfo = async (email) => {
    try {
        const resp = await axios.get(`https://pplp.titan.io/shares/${email}`)
        if(resp.status === 204) {
            return null;
        }
        return resp.data[0];
    }
    catch(e) {
        console.error(e.message);
        return null;
    }
}